const { WalletStatusList, WalletFeatures } = require('pando-constants');
// TODO: rename required
class WalletStatusUtils {
  static getStatusObjById(statusId) {
    return WalletStatusList.find(status => status.id === statusId);
  }
  static getStatusObjByName(statusName) {
    return WalletStatusList.find(status => status.name === statusName);
  }
  static isActionPossible(previousStatusId, newStatusId, clientType, isApprovalFlow) {
    const newStatusObj = WalletStatusUtils.getStatusObjById(newStatusId);
    let isPossible = false;
    if (newStatusObj) {
      const feature = isApprovalFlow ? WalletFeatures.APPROVAL_FLOW : WalletFeatures.DEFAULT;
      const result = newStatusObj.parent.find(parent =>
        parent.features === feature && parent.actionAllowedParty === clientType);
      if (result && result.ids.indexOf(previousStatusId) >= 0) {
        isPossible = true;
      }
    }
    return isPossible;
  }
}

module.exports = WalletStatusUtils;
